function escapeHTML(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function keyPreviewHTML(you) {
  if (!you || !you.publicKey) {
    return '';
  }
  var icon = you.identicon ? "<div class=\"saito-identicon-box\"><img class=\"saito-identicon\" src=\"".concat(escapeHTML(you.identicon), "\" alt=\"\"></div>") : '';
  return "\n    <div class=\"key-preview key-preview--enter-active\" data-key-preview>\n      <div class=\"saito-user\">\n        ".concat(icon, "\n        <div class=\"saito-address\" title=\"").concat(escapeHTML(you.publicKey), "\">").concat(escapeHTML(you.publicKey), "</div>\n        <div class=\"saito-userline\">").concat(escapeHTML(you.email || you.name || ''), "</div>\n      </div>\n    </div>\n  ");
}
module.exports = {
  escapeHTML: escapeHTML,
  keyPreviewHTML: keyPreviewHTML
};